module.exports = __webpack_public_path__ + "assets/img/box.8714e215.jpg";